export default __webpack_public_path__ + "static/media/ppm.41287411.svg";